import _ from 'lodash';
import dayjs from 'dayjs';
import {
  parseArrayParam,
  parseStringParam,
  buildQueryString,
  useUrlState,
} from '../../utils/urlParams';
import { currentTermRange } from '../../dates';

const SCOPE_FILTER_KEYS = ['classIds', 'subjectCodes', 'taskTypes', 'taskIds', 'studentIds'];
const DATE_RANGE_KEYS = ['startDate', 'endDate'];
const TILE_SELECTION_KEYS = ['commentBankIds', 'successCriteriaIds', 'rubricIds', 'shortAnswerIds'];
const SORT_KEYS = ['sortByRubrics', 'sortByShortAnswer'];

const parseFilters = (search) => {
  const p = new URLSearchParams(search);
  const scope = _.fromPairs(_.map(SCOPE_FILTER_KEYS, (k) => [k, parseArrayParam(p, k)]));
  const dateRange = _.fromPairs(_.map(DATE_RANGE_KEYS, (k) => [k, parseStringParam(p, k)]));
  const tileSelections = _.fromPairs(_.map(TILE_SELECTION_KEYS, (k) => [k, parseArrayParam(p, k)]));
  const sorts = _.fromPairs(_.map(SORT_KEYS, (k) => [k, parseStringParam(p, k)]));
  return { ...scope, ...dateRange, ...tileSelections, ...sorts };
};

const buildSearch = (filters) =>
  buildQueryString(
    _.map([...SCOPE_FILTER_KEYS, ...TILE_SELECTION_KEYS], (k) => [k, filters[k]]),
    _.map([...DATE_RANGE_KEYS, ...SORT_KEYS], (k) => [k, filters[k]]),
  );

export const withDateDefaults = (filters) => {
  const d = currentTermRange();
  return {
    ...filters,
    startDate: filters.startDate || d.startDate,
    endDate: filters.endDate || dayjs().format('YYYY-MM-DD'),
  };
};

export const statsBody = (filters) => {
  const withDates = withDateDefaults(filters);
  const scope = _.fromPairs(_.map(SCOPE_FILTER_KEYS, (k) => [k, withDates[k] || []]));
  return { ...scope, startDate: withDates.startDate, endDate: withDates.endDate };
};

export const useFilters = () => {
  const { state: filters, setState: setFilters } = useUrlState(parseFilters, buildSearch);
  return { filters, setFilters };
};
